module.exports = __webpack_public_path__ + "static/media/Ebamag.0c63cff0.jpg";